import "//shopakaso.com/cdn/shop/t/25/assets/jquery.js?v=147293088974801289311780911872";

// 入口函数，在页面加载完成后执行
function main() {
  Alpine.data("ek7000pc", function () {
    const el = $(this);

    return {
      localName: window.Shopify.locale,
      init() {
        /* 页面刷新时执行 */
        window.onload = function () {
          if (document.body.scrollTop > 0) {
            window.scrollTo(0, -1)
            document.body.scrollTop = 0
          }
          window.scrollTo(0, -1)
          document.body.scrollTop = 0
        }
        /* 页面刷新时执行 */
        $(function () {
          if (window.innerWidth > 1024) {
            /* 滑动 */
            $(window).scroll(function (event) {
              if ($(window).scrollTop() > 0) {
                $(".product-details-top").addClass("product-details-special");
                $(".header-wrapper").hide();
              } else {
                $(".product-details-top").removeClass("product-details-special");
                $(".header-wrapper").show();
              }
            });
            /* 滑动 */
            /* 第一屏刷新时渐入文字 */
            function chen () {
              setTimeout(function () {
                $('.poster-one-title-box').addClass('container-add-spec')
              }, 100)
              setTimeout(function () {
                $('.poster-one-word-box').addClass('container-add-spec')
              }, 200)
            }
            chen()
            /* 第一屏刷新时渐入文字 */
      
            /* 点击事件 */
            $('.get-creative-icon-one').click(function () {
              console.log(1212)
              $('.get-creative-tabs').hide(50)
              $('.get-creative-content').show(50)
              $('.get-creative-item-two').hide(50)
              $('.get-creative-item-three').hide(50)
              $('.get-creative-item-one').fadeIn(500)
              setTimeout(function () {
                $('.get-creative-title-box1').addClass('container-add-spec')
              }, 400)
              setTimeout(function () {
                $('.get-creative-name-box1').addClass('container-add-spec')
              }, 400)
            })
            $('.get-creative-icon-return-one').click(function () {
              $('.get-creative-content').hide(50)
              $('.get-creative-tabs').show(50)
              $('.get-creative-item-one').hide(50)
              $('.get-creative-item-two').hide(50)
              $('.get-creative-item-three').hide(50)
              $('.get-creative-title-box1').removeClass('container-add-spec')
              $('.get-creative-name-box1').removeClass('container-add-spec')
            })
            $('.get-creative-icon-two').click(function () {
              $('.get-creative-tabs').hide(50)
              $('.get-creative-content').show(50)
              $('.get-creative-item-one').hide(50)
              $('.get-creative-item-three').hide(50)
              $('.get-creative-item-two').fadeIn(500)
              setTimeout(function () {
                $('.get-creative-title-box2').addClass('container-add-spec')
              }, 400)
              setTimeout(function () {
                $('.get-creative-name-box2').addClass('container-add-spec')
              }, 400)
            })
            $('.get-creative-icon-return-two').click(function () {
              $('.get-creative-content').hide(50)
              $('.get-creative-tabs').show(50)
              $('.get-creative-item-one').hide(50)
              $('.get-creative-item-two').hide(50)
              $('.get-creative-item-three').hide(50)
              $('.get-creative-title-box2').removeClass('container-add-spec')
              $('.get-creative-name-box2').removeClass('container-add-spec')
            })
            $('.get-creative-icon-three').click(function () {
              $('.get-creative-tabs').hide(50)
              $('.get-creative-content').show(50)
              $('.get-creative-item-one').hide(50)
              $('.get-creative-item-two').hide(50)
              $('.get-creative-item-three').fadeIn(500)
              setTimeout(function () {
                $('.get-creative-title-box3').addClass('container-add-spec')
              }, 400)
              setTimeout(function () {
                $('.get-creative-name-box3').addClass('container-add-spec')
              }, 400)
            })
            $('.get-creative-icon-return-three').click(function () {
              $('.get-creative-content').hide(50)
              $('.get-creative-tabs').show(50)
              $('.get-creative-item-one').hide(50)
              $('.get-creative-item-two').hide(50)
              $('.get-creative-item-three').hide(50)
              $('.get-creative-title-box3').removeClass('container-add-spec')
              $('.get-creative-name-box3').removeClass('container-add-spec')
            })
      
            let one = false
            let two = true
            let three = true
            let four = true
            $('.poster-ten-tab-top-one').click(function () {
              $('.poster-ten-tab-info').hide()
              if (one) {
                $('.poster-ten-tab-info-one').show()
                $('.poster-ten-tab-icon-one').addClass('poster-ten-tab-icon-spec')
                one = false
              } else {
                $('.poster-ten-tab-info-one').hide()
                $('.poster-ten-tab-icon-one').removeClass('poster-ten-tab-icon-spec')
                one = true
              }
              $('.poster-ten-image').hide()
              $('.poster-ten-image-one').show()
              two = true
              three = true
              four = true
              $('.poster-ten-tab-icon-two').removeClass('poster-ten-tab-icon-spec')
              $('.poster-ten-tab-icon-three').removeClass('poster-ten-tab-icon-spec')
              $('.poster-ten-tab-icon-four').removeClass('poster-ten-tab-icon-spec')
            })
            $('.poster-ten-tab-top-two').click(function () {
              $('.poster-ten-tab-info').hide()
              if (two) {
                $('.poster-ten-tab-info-two').show()
                $('.poster-ten-tab-icon-two').addClass('poster-ten-tab-icon-spec')
                two = false
              } else {
                $('.poster-ten-tab-info-two').hide()
                $('.poster-ten-tab-icon-two').removeClass('poster-ten-tab-icon-spec')
                two = true
              }
              $('.poster-ten-image').hide()
              $('.poster-ten-image-two').show()
              one = true
              three = true
              four = true
              $('.poster-ten-tab-icon-one').removeClass('poster-ten-tab-icon-spec')
              $('.poster-ten-tab-icon-three').removeClass('poster-ten-tab-icon-spec')
              $('.poster-ten-tab-icon-four').removeClass('poster-ten-tab-icon-spec')
            })
            $('.poster-ten-tab-top-three').click(function () {
              $('.poster-ten-tab-info').hide()
              if (three) {
                $('.poster-ten-tab-info-three').show()
                $('.poster-ten-tab-icon-three').addClass('poster-ten-tab-icon-spec')
                three = false
              } else {
                $('.poster-ten-tab-info-three').hide()
                $('.poster-ten-tab-icon-three').removeClass('poster-ten-tab-icon-spec')
                three = true
              }
              $('.poster-ten-image').hide()
              $('.poster-ten-image-three').show()
              one = true
              two = true
              four = true
              $('.poster-ten-tab-icon-one').removeClass('poster-ten-tab-icon-spec')
              $('.poster-ten-tab-icon-two').removeClass('poster-ten-tab-icon-spec')
              $('.poster-ten-tab-icon-four').removeClass('poster-ten-tab-icon-spec')
            })
            $('.poster-ten-tab-top-four').click(function () {
              $('.poster-ten-tab-info').hide()
              if (four) {
                $('.poster-ten-tab-info-four').show()
                $('.poster-ten-tab-icon-four').addClass('poster-ten-tab-icon-spec')
                four = false
              } else {
                $('.poster-ten-tab-info-four').hide()
                $('.poster-ten-tab-icon-four').removeClass('poster-ten-tab-icon-spec')
                four = true
              }
              $('.poster-ten-image').hide()
              $('.poster-ten-image-four').show()
              one = true
              two = true
              three = true
              $('.poster-ten-tab-icon-one').removeClass('poster-ten-tab-icon-spec')
              $('.poster-ten-tab-icon-two').removeClass('poster-ten-tab-icon-spec')
              $('.poster-ten-tab-icon-three').removeClass('poster-ten-tab-icon-spec')
            })
            /* 点击事件 */
      
            /* 下滑文字效果 */
            $(window).scroll(function (event) {
              /* 面包屑 */
              if ($(window).scrollTop() > 146) {
                $('.product-details-top').addClass('product-details-special')
                $('.header').addClass('header-special')
                $('.header').css('visibility', 'hidden')
              } else if ($(window).scrollTop() < 82) {
                $('.product-details-top').removeClass('product-details-special')
                $('.header').removeClass('header-special')
                $('.header').css('visibility', 'visible')
              } else {
                $('.product-details-top').addClass('product-details-special')
                $('.header').addClass('header-special')
                $('.header').css('visibility', 'hidden')
              }
              /* 面包屑 */
      
              const wst = $(window).scrollTop()
              const st = wst + 56
              const wh = $(window).height()
      
              /* section two */
      
              const xf = $('.poster-two').offset().top
              const xf1 = xf + 100
              const xf2 = xf + 200
              const xf3 = xf + 300
              const xf4 = xf + 400
              const xf5 = xf + 500
              const xf6 = xf + 600
              const xf7 = xf + 700
              const xf8 = xf + 800
              const xf9 = xf + 900
              const xf10 = xf + 1000
              const xf11 = xf + 1100
              const xf12 = xf + 1200
              const xf13 = xf + 1300
              const xf14 = xf + 1400
              console.log(888)
              console.log(st)
              console.log(xf)
              console.log(xf1)
              if (st < xf) {
                console.log(12)
                $('.ek7000-camera-other').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-images').show()
                $('.ek7000-camera-img').hide()
                $('.ek7000-camera-img1').show()
              } else if (st > xf && st < xf1) {
                console.log(23)
                $('.ek7000-camera-other').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-images').show()
                $('.ek7000-camera-img').hide()
                $('.ek7000-camera-img2').show()
              } else if (st > xf1 && st < xf2) {
                console.log(34)
                $('.ek7000-camera-other').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-images').show()
                $('.ek7000-camera-img').hide()
                $('.ek7000-camera-img3').show()
              } else if (st > xf2 && st < xf3) {
                console.log(45)
                $('.ek7000-camera-other').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-images').show()
                $('.ek7000-camera-img').hide()
                $('.ek7000-camera-img4').show()
              } else if (st > xf3 && st < xf4) {
                console.log(56)
                $('.ek7000-camera-other').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-images').show()
                $('.ek7000-camera-img').hide()
                $('.ek7000-camera-img5').show()
              } else if (st > xf4 && st < xf5) {
                console.log(67)
                $('.ek7000-camera-other').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-images').show()
                $('.ek7000-camera-img').hide()
                $('.ek7000-camera-img6').show()
              } else if (st > xf5 && st < xf6) {
                console.log(78)
                $('.ek7000-camera-other').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-images').show()
                $('.ek7000-camera-img').hide()
                $('.ek7000-camera-img7').show()
              } else if (st > xf6 && st < xf7) {
                console.log(90)
                $('.ek7000-camera-other').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-images').show()
                $('.ek7000-camera-img').hide()
                $('.ek7000-camera-img8').show()
              } else if (st > xf7 && st < xf8) {
                $('.ek7000-camera-other').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-images').show()
                $('.ek7000-camera-img').hide()
                $('.ek7000-camera-img9').show()
              } else if (st > xf8 && st < xf9) {
                $('.ek7000-camera-other').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-images').show()
                $('.ek7000-camera-img').hide()
                $('.ek7000-camera-img10').show()
              } else if (st > xf9 && st < xf10) {
                $('.ek7000-camera-other').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-images').show()
                $('.ek7000-camera-img').hide()
                $('.ek7000-camera-img11').show()
              } else if (st > xf10 && st < xf11) {
                $('.ek7000-camera-images').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-other').show()
                $('.ek7000-camera-other-item').hide()
                $('.ek7000-camera-other-item1').show()
              } else if (st > xf11 && st < xf12) {
                $('.ek7000-camera-images').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-other').show()
                $('.ek7000-camera-other-item').hide()
                $('.ek7000-camera-other-item2').show()
              } else if (st > xf12 && st < xf13) {
                $('.ek7000-camera-images').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-other').show()
                $('.ek7000-camera-other-item').hide()
                $('.ek7000-camera-other-item3').show()
              } else if (st > xf13 && st < xf14) {
                $('.ek7000-camera-images').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-other').show()
                $('.ek7000-camera-other-item').hide()
                $('.ek7000-camera-other-item4').show()
              } else if (st > xf14) {
                $('.ek7000-camera-images').hide()
                $('.ek7000-camera-other').hide()
                $('.ek7000-camera-color').show()
                $('.ek7000-camera-other-item').hide()
                $('.ek7000-camera-other-item5').show()
                setTimeout(function () {
                  $('.ek7000-camera-other-color-inner-box').addClass('container-add-spec')
                }, 100)
              }
      
              /* section two */
      
              /* section three */
      
              const ptot = $('.poster-three-one-title').offset().top
              const ptots = ptot - wh
              const ptow = $('.poster-three-one-word').offset().top
              const ptows = ptow - wh
              if (st > ptots) {
                setTimeout(function () {
                  $('.poster-three-one-title-box').addClass('container-add-spec')
                }, 100)
              }
              if (st > ptows) {
                setTimeout(function () {
                  $('.poster-three-one-word-box').addClass('container-add-spec')
                }, 200)
              }
              const pttt = $('.poster-three-two-title').offset().top
              const pttts = pttt - wh
              const pttw = $('.poster-three-two-word').offset().top
              const pttws = pttw - wh
              if (st > pttts) {
                setTimeout(function () {
                  $('.poster-three-two-title-box').addClass('container-add-spec')
                }, 100)
              }
              if (st > pttws) {
                setTimeout(function () {
                  $('.poster-three-two-word-box').addClass('container-add-spec')
                }, 200)
              }
      
              /* section three */
      
              /* section four */
      
              const pft = $('.poster-four-title').offset().top
              const pfts = pft - wh
              const pfw = $('.poster-four-word').offset().top
              const pfws = pfw - wh
              if (st > pfts) {
                setTimeout(function () {
                  $('.poster-four-title-box').addClass('container-add-spec')
                }, 100)
              }
              if (st > pfws) {
                setTimeout(function () {
                  $('.poster-four-word-box').addClass('container-add-spec')
                }, 200)
              }
      
              /* section four */
      
              /* section five */
      
              const pit = $('.poster-five-title').offset().top
              const pits = pit - wh
              const piw = $('.poster-five-word').offset().top
              const piws = piw - wh
              if (st > pits) {
                setTimeout(function () {
                  $('.poster-five-title-box').addClass('container-add-spec')
                }, 100)
              }
              if (st > piws) {
                setTimeout(function () {
                  $('.poster-five-word-box').addClass('container-add-spec')
                }, 200)
              }
      
              /* section five */
      
              /* section six */
      
              const pst = $('.poster-six-title').offset().top
              const psts = pst - wh
              const psw = $('.poster-six-word').offset().top
              const psws = psw - wh
              if (st > psts) {
                setTimeout(function () {
                  $('.poster-six-title-box').addClass('container-add-spec')
                }, 100)
              }
              if (st > psws) {
                setTimeout(function () {
                  $('.poster-six-word-box').addClass('container-add-spec')
                }, 200)
              }
      
              /* section six */
      
              /* section seven */
      
              const pet = $('.poster-seven-title').offset().top
              const pets = pet - wh
              if (st > pets) {
                setTimeout(function () {
                  $('.poster-seven-title-box').addClass('container-add-spec')
                }, 100)
              }
      
              /* section seven */
      
              /* section eight */
      
              const targetElement = $('.poster-seven').offset().top
              if (st > targetElement) {
                const widthNew = st - targetElement
                const width = widthNew / 4
                // const wipeNew = width / 146
                // const wipeNews = 100 - wipeNew * 100
                // const wipe = wipeNews + '%'
                if (width <= 146) {
                  $('.total-runtime-img').css('width', width)
                  // $('.total-runtime-title').css('--wipe', wipe)
                } else {
                  $('.total-runtime-img').css('width', '146px')
                  // $('.total-runtime-title').css('--wipe', '0%')
                }
              }
              const trt = $('.total-runtime-title').offset().top
              const trts = trt - wh
              if (st > trts) {
                setTimeout(function () {
                  $('.total-runtime-title-box').addClass('container-add-spec')
                }, 100)
              }
              const trw = $('.total-runtime-word').offset().top
              const trws = trw - wh
              if (st > trws) {
                setTimeout(function () {
                  $('.total-runtime-word-box').addClass('container-add-spec')
                }, 200)
              }
      
              /* section eight */
      
              /* section nine */
      
              const pnt = $('.poster-nine-title').offset().top
              const pnts = pnt - wh
              if (st > pnts) {
                setTimeout(function () {
                  $('.poster-nine-title-box').addClass('container-add-spec')
                }, 100)
              }
              const pnn = $('.poster-nine-name').offset().top
              const pnns = pnn - wh
              if (st > pnns) {
                setTimeout(function () {
                  $('.poster-nine-name-box').addClass('container-add-spec')
                }, 100)
              }
              const pnp = $('.poster-nine-tip').offset().top
              const pnps = pnp - wh
              if (st > pnps) {
                setTimeout(function () {
                  $('.poster-nine-tip-box').addClass('container-add-spec')
                }, 200)
              }
              const nx = $('.poster-nine').offset().top
              const mx = nx
              const qx = mx + 712
              const wx = mx + 1412
              const ex = mx + 2136
              if (st < qx) {
                console.log(1111)
                $('.poster-nine-item').hide()
                $('.poster-nine-item-one').show()
                setTimeout(function () {
                  $('.poster-nine-item-box-one').addClass('container-add-spec')
                }, 100)
              } else if (st > qx && st < wx) {
                console.log(3333)
                $('.poster-nine-item').hide()
                $('.poster-nine-item-three').show()
                setTimeout(function () {
                  $('.poster-nine-item-box-three').addClass('container-add-spec')
                }, 100)
              } else if (st > wx && st < ex) {
                console.log(4444)
                $('.poster-nine-item').hide()
                $('.poster-nine-item-four').show()
                setTimeout(function () {
                  $('.poster-nine-item-box-four').addClass('container-add-spec')
                }, 100)
              } else if (st > ex) {
                console.log(5555)
                $('.poster-nine-item').hide()
                $('.poster-nine-item-five').show()
                setTimeout(function () {
                  $('.poster-nine-item-box-five').addClass('container-add-spec')
                }, 100)
              }
      
              /* section nine */
      
              /* section ten */
      
              const ptt = $('.poster-ten-title').offset().top
              const ptts = ptt - wh
              if (st > ptts) {
                setTimeout(function () {
                  $('.poster-ten-title-box').addClass('container-add-spec')
                }, 100)
              }
              console.log(1718)
              console.log(one)
              console.log(two)
              console.log(three)
              console.log(four)
              const ny = $('.poster-ten').offset().top
              const my = ny
              const qy = my + 556
              const wy = my + 1112
              const ey = my + 1668
              if (st < qy) {
                $('.poster-ten-tab-info').hide()
                $('.poster-ten-tab-info-one').show()
                $('.poster-ten-tab-icon-one').addClass('poster-ten-tab-icon-spec')
                one = false
                $('.poster-ten-image').hide()
                $('.poster-ten-image-one').show()
                two = true
                three = true
                four = true
                $('.poster-ten-tab-icon-two').removeClass('poster-ten-tab-icon-spec')
                $('.poster-ten-tab-icon-three').removeClass('poster-ten-tab-icon-spec')
                $('.poster-ten-tab-icon-four').removeClass('poster-ten-tab-icon-spec')
              } else if (st > qy && st < wy) {
                $('.poster-ten-tab-info').hide()
                $('.poster-ten-tab-info-two').show()
                $('.poster-ten-tab-icon-two').addClass('poster-ten-tab-icon-spec')
                two = false
                $('.poster-ten-image').hide()
                $('.poster-ten-image-two').show()
                one = true
                three = true
                four = true
                $('.poster-ten-tab-icon-one').removeClass('poster-ten-tab-icon-spec')
                $('.poster-ten-tab-icon-three').removeClass('poster-ten-tab-icon-spec')
                $('.poster-ten-tab-icon-four').removeClass('poster-ten-tab-icon-spec')
              } else if (st > wy && st < ey) {
                $('.poster-ten-tab-info').hide()
                $('.poster-ten-tab-info-three').show()
                $('.poster-ten-tab-icon-three').addClass('poster-ten-tab-icon-spec')
                three = false
                $('.poster-ten-image').hide()
                $('.poster-ten-image-three').show()
                one = true
                two = true
                four = true
                $('.poster-ten-tab-icon-one').removeClass('poster-ten-tab-icon-spec')
                $('.poster-ten-tab-icon-two').removeClass('poster-ten-tab-icon-spec')
                $('.poster-ten-tab-icon-four').removeClass('poster-ten-tab-icon-spec')
              } else if (st > ey) {
                $('.poster-ten-tab-info').hide()
                $('.poster-ten-tab-info-four').show()
                $('.poster-ten-tab-icon-four').addClass('poster-ten-tab-icon-spec')
                four = false
                $('.poster-ten-image').hide()
                $('.poster-ten-image-four').show()
                one = true
                two = true
                three = true
                $('.poster-ten-tab-icon-one').removeClass('poster-ten-tab-icon-spec')
                $('.poster-ten-tab-icon-two').removeClass('poster-ten-tab-icon-spec')
                $('.poster-ten-tab-icon-three').removeClass('poster-ten-tab-icon-spec')
              }
      
              /* section ten */
      
              /* section eleven */
      
              const pe = $('.poster-ten').offset().top
              const pd = st - pe
              const pk = pd / 150
              const pf = 50 + pk
              const pg = 50 - pk
              if (st > pe) {
                $('.poster-eleven-row-one').css('transform', 'translateX(-' + pf + '%)')
                $('.poster-eleven-row-two').css('transform', 'translateX(-' + pg + '%)')
                $('.poster-eleven-row-one').css('transition', 'all 0.5s linear')
                $('.poster-eleven-row-two').css('transition', 'all 0.5s linear')
              } else {
                $('.poster-eleven-row-one').css('transform', 'translateX(-50%)')
                $('.poster-eleven-row-two').css('transform', 'translateX(-50%)')
                $('.poster-eleven-row-one').css('transition', 'all 0.5s linear')
                $('.poster-eleven-row-two').css('transition', 'all 0.5s linear')
              }
      
              /* section eleven */
            })
            /* 下滑文字效果 */
          }
        })
      },
    };
  });
}

document.addEventListener("alpine:init", main);
